var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signin"}},[_c('h2',[_vm._v("サインイン")]),_c('button',{on:{"click":_vm.signIn}},[_vm._v("匿名ユーザでサインイン")]),_c('br'),_c('button',{on:{"click":_vm.signInWithGoogle}},[_vm._v("Googleアカウントでサインイン")])])}
var staticRenderFns = []

export { render, staticRenderFns }